export default () => [
    {
        term: "Annual Fee",
        definition:
            "A fee charged annually on an open line of credit, regardless of whether the line of credit is used.",
    },
    {
        term: "Annual Percentage Rate (APR)",
        definition:
            "The annual cost of a loan to a borrower. Like an interest rate, the APR is expressed as a percentage. Unlike an interest rate, however, it includes other charges or fees to reflect the total cost of the loan. The Federal Truth in Lending Act requires that every consumer loan agreement disclose the APR. Since all lenders must follow the same rules to ensure the accuracy of the APR, borrowers can use the APR as a good basis for comparing the costs of similar credit transactions.",
    },
    {
        term: "APR vs. Interest Rate",
        definition:
            "The interest rate is the cost you will pay each year to borrow money, expressed as a percentage rate. It does not reflect fees or any other charges you may have to pay for the loan or line of credit .",
        definition1:
            "An annual percentage rate (APR) is a broader measure of the cost of borrowing money than the interest rate.  The APR reflects the interest rate and other charges or fees that you pay to get the loan or line of credit. For that reason, your APR is usually higher than your interest rate. The Federal Truth in Lending Act requires that every consumer credit agreement disclose the APR. Since all providers must follow the same rules to ensure the accuracy of the APR, borrowers can use the APR as a good basis for comparing the costs of credit transactions.",
    },
    {
        term: "Borrower",
        definition:
            "An individual or business that borrows money pursuant to a credit agreement. Receiving a loan or using a line of credit entails a payment obligation in accordance with the terms of the credit agreement.",
    },
    {
        term: "Co-Borrower",
        definition:
            "A co-borrower is any additional borrower who is obligated on the creditagreement and whose income and credit history are used to qualify for the loan.",
    },
    {
        term: "Credit Bureau",
        definition:
            "An organization that gathers, records, updates and stores financial and public record information of individuals and provides this information to creditors and other authorized users for a fee. The 3 major credit bureaus are Equifax, Experian and TransUnion.  Information about accessing a free copy of your credit report from each of these credit bureaus is available at https://www.annualcreditreport.com/.",
    },
    {
        term: "Credit Inquiry",
        definition: "A request for your credit report, such as by a company considering your credit application.",
    },
    {
        term: "Credit Limit",
        definition: "The maximum amount you can borrow under a line of credit.",
    },
    {
        term: "Credit Report",
        definition:
            "A record of an individual's debts and payment habits. It helps a company determine whether or not a potential borrower is a good credit risk.",
    },
    {
        term: "Credit Score",
        definition:
            "A number that rates the quality of an individual's credit. The number helps predict the relative likelihood that a person will repay a credit obligation. Generally, a higher score indicates a stronger probability that a person will make payments on time.  Individuals have more than one credit score.  Any credit score depends on the data used to calculate it, and may differ depending on the scoring model, the source of your credit history, the type of loan product, and even the day when it was calculated.",
    },
    {
        term: "Deferred Interest",
        definition:
            "This is the interest that accrues during the Promotional Period. With a “No Interest if Paid in Full within the Promotional Period” special financing option, this interest is added to your account if you do not pay off your full balance within the agreed to Promotional Period. To avoid paying the accrued interest, the entire balance must be paid in full prior to the end of the Promotional Period.",
    },
    {
        term: "Down Payment",
        definition:
            "Payment made out of pocket by the patient, prior to or separately from entering into a loan agreement.",
    },
    {
        term: "Reduced APR Promotional Financing",
        definition:
            "A reduced APR promotional financing breaks down the total into payments the patient can handle, as well as outlines exactly what the patient will be paying, making what they owe at what time much clearer. It tells the patient how long the payment plan will last as well as the interest rate.",
    },
    {
        term: "Finance Charge",
        definition:
            "The cost of consumer credit expressed as a dollar amount. It includes, for example, interest and origination fees, if any.",
    },

    {
        term: "Installment Loan",
        definition:
            "A loan that is repaid in substantially equal payments, known as installments.  Payments are applied to fees, interest and principal (in the order determined by the lender or as required by applicable law).",
    },
    {
        term: "Interest Rate",
        definition:
            "The annual cost of a loan to a borrower, usually expressed as a percentage. The interest rate does not include fees charged for the loan.",
    },
    {
        term: "Lender",
        definition: "A company that lends money to a borrower.",
    },
    {
        term: "Loan Term",
        definition:
            "The number of months or years it will take to pay off an installment loan. The loan term is used to determine the payment amount, repayment schedule and total interest paid over the life of an installment loan.",
    },
    {
        term: "Maturity Date",
        definition:
            "The date on which the outstanding principal, interest and fees on an installment loan must all be repaid.",
    },
    {
        term: "Minimum Monthly Payment",
        definition:
            "The minimum monthly payment is the lowest amount a customer can pay on their revolving line of credit or credit card account per month and remain in good standing with the lender. Making the monthly minimum payment on time is the least a consumer needs to do to avoid late fees and to have an on-time repayment history on their credit report. The calculation method of the minimum monthly payment with a revolving loan or credit card may vary between products offered, but is typically a percentage of the account balance and may or may not include fees such as late fees. ",
    },
    {
        term: "Monthly Payment",
        definition:
            "Your monthly payment is what you pay to the lender each month to repay your installment loan. The amount you pay every month depends on the terms of your installment loan. This includes the principal, which is the amount you borrowed, interest, and the loan term or length.",
    },
    {
        term: "Payment Due Date",
        definition:
            "The date by which each payment is due on an installment loan, revolving loan, or credit card account.",
    },
    {
        term: "Prequalification",
        definition:
            "The process of providing financial and other information by a prospective borrower in order for the lender to preliminarily estimate the loan amount, rate, and other terms of credit the consumer could qualify for if they submit an application and are approved for credit. A prequalification is not a commitment to lend.",
    },
    {
        term: "Principal Balance",
        definition: "The unpaid portion of the installment loan amount.",
    },
    {
        term: "Principal Payment",
        definition: "The portion of your monthly payment that reduces the principal balance of the loan.",
    },
    {
        term: "Repayment Period",
        definition:
            "The time you have to fully repay your outstanding balance, according to the terms of your installment loan agreement.",
    },
    {
        term: "Revolving Line of Credit",
        definition:
            "An agreement to lend up to a specific amount to a borrower and to allow that amount to be accessed repeatedly as it is repaid. The credit is 'revolving' in the sense that the line of credit remains open and can be used up to the maximum limit repeatedly, as long as the borrower makes a minimum monthly payment on time.",
    },
]
